import { RefObject, useCallback, useEffect, useLayoutEffect, useRef } from 'react';
import { NativeScrollEvent, NativeSyntheticEvent, ScrollView } from 'react-native';

/** Keep the details scroll position while the inline acceptance review is open. */
export default function useMissionPanelScroll(scroll: RefObject<ScrollView | null>, subpageOpen: boolean, scope: string) {
  const detailsOffset = useRef(0);
  const previous = useRef(false);
  const active = useRef(subpageOpen);
  const context = useRef(scope);
  const frame = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  active.current = subpageOpen;
  const scrollTo = useCallback((y: number) => {
    clearTimeout(frame.current);
    frame.current = setTimeout(() => scroll.current?.scrollTo({ y, animated: false }), 0);
  }, [scroll]);
  useLayoutEffect(() => {
    if (context.current !== scope) {
      context.current = scope;
      detailsOffset.current = 0;
      previous.current = false;
      scrollTo(0);
    }
    if (previous.current !== subpageOpen) scrollTo(subpageOpen ? 0 : detailsOffset.current);
    previous.current = subpageOpen;
  }, [subpageOpen, scrollTo, scope]);
  useEffect(() => () => clearTimeout(frame.current), []);
  const onScroll = useCallback((event: NativeSyntheticEvent<NativeScrollEvent>) => {
    if (!active.current) detailsOffset.current = event.nativeEvent.contentOffset.y;
  }, []);
  return { onScroll, toTop: useCallback(() => scrollTo(0), [scrollTo]) };
}
